export const getProjectLink = (id: string) => {
  return `/projects/${id}`
}
